// Keep this imports only for type module declaration (cf node_modules/dayjs/plugin/timezone.d.ts for ex.)
import 'dayjs/plugin/advancedFormat';
import 'dayjs/plugin/customParseFormat';
import 'dayjs/plugin/dayOfYear';
import 'dayjs/plugin/duration';
import 'dayjs/plugin/localeData';
import 'dayjs/plugin/localizedFormat';
import 'dayjs/plugin/relativeTime';
import 'dayjs/plugin/timezone';
import 'dayjs/plugin/utc';

import { getDayjs } from '@hivebrite/utils';

const dayjs = getDayjs({
  language: window.I18n?.locale,
});

export default dayjs;
